import { useState } from 'react';
import cn from 'classnames';
import { Badge, Box, Callout, Collapse, Column, Divider, FullRow, Row, Switch, TextButton, Typography } from 'seagull';
import { Bulb24 } from 'seagull/icons';
import { Intent } from "../../../../../../../infra/access-control";
import styles from "./ServiceItem.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DesktopServiceItem = _ref => {
  var _service$bundle;
  let {
    service,
    isOptional,
    isSelected,
    onToggle,
    isDisabled,
    discountBadgeData,
    getBillingBadgeText,
    futureBillingText,
    renderPrice,
    hasIncludedServices,
    hasExpandableContent,
    getServiceDescription,
    ServiceItemTestIds
  } = _ref;
  const [isExpanded, setIsExpanded] = useState(false);
  return /*#__PURE__*/_jsx(Column, {
    className: cn(styles.serviceItem, {
      [styles.disabled]: isDisabled
    }),
    "data-testid": ServiceItemTestIds.Root(),
    children: /*#__PURE__*/_jsxs(Column, {
      className: styles.card,
      children: [/*#__PURE__*/_jsxs(Column, {
        gap: 8,
        children: [/*#__PURE__*/_jsxs(FullRow, {
          gap: 16,
          alignItems: "center",
          children: [isOptional && /*#__PURE__*/_jsx(Switch, {
            intent: Intent.SelectOptionalService,
            checked: isSelected,
            "data-testid": ServiceItemTestIds.OptionalToggle(),
            onChange: onToggle
          }), /*#__PURE__*/_jsx(Typography, {
            className: styles.serviceName,
            skin: isDisabled ? 'secondary' : 'standard',
            ellipsis: true,
            "data-testid": ServiceItemTestIds.Name(),
            children: service.name
          }), /*#__PURE__*/_jsxs(Row, {
            gap: 8,
            children: [discountBadgeData && /*#__PURE__*/_jsx(Badge, {
              rounded: true,
              outlined: true,
              skin: "primary",
              "data-testid": ServiceItemTestIds.DiscountBadge(),
              children: discountBadgeData.text
            }), /*#__PURE__*/_jsx(Badge, {
              rounded: true,
              outlined: true,
              skin: "primary",
              "data-testid": ServiceItemTestIds.BillingBadge(),
              children: getBillingBadgeText()
            })]
          }), /*#__PURE__*/_jsx(Box, {
            "data-testid": ServiceItemTestIds.Price(),
            children: renderPrice()
          }), hasExpandableContent && /*#__PURE__*/_jsxs(Row, {
            gap: 16,
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(Divider, {
              orientation: "vertical",
              margin: 0,
              className: styles.viewMoreDivider
            }), /*#__PURE__*/_jsx(TextButton, {
              underline: "none",
              weight: "normal",
              variant: "paragraph2",
              className: styles.viewMoreButton,
              onClick: () => setIsExpanded(!isExpanded),
              "data-testid": ServiceItemTestIds.ExpandButton(),
              children: isExpanded ? 'View less' : 'View more'
            })]
          })]
        }), hasIncludedServices && /*#__PURE__*/_jsxs(Column, {
          gap: 4,
          "data-testid": ServiceItemTestIds.IncludedServices(),
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "paragraph2",
            weight: "normal",
            children: "Included services:"
          }), /*#__PURE__*/_jsx("ul", {
            className: styles.includedServicesList,
            children: (_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services.map(includedService => /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                weight: "light",
                children: includedService.name
              })
            }, includedService.serviceTemplateId))
          })]
        }), futureBillingText && /*#__PURE__*/_jsx(Callout, {
          variant: "paragraph2",
          intent: "info",
          icon: /*#__PURE__*/_jsx(Bulb24, {
            width: 24,
            height: 24
          }),
          classes: {
            main: styles.futureBillingCallout
          },
          "data-testid": ServiceItemTestIds.FutureBillingCallout(),
          children: futureBillingText
        })]
      }), hasExpandableContent && /*#__PURE__*/_jsx(Collapse, {
        in: isExpanded,
        children: /*#__PURE__*/_jsx(Column, {
          gap: 16,
          className: styles.expandedContent,
          "data-testid": ServiceItemTestIds.ExpandedContent(),
          children: getServiceDescription({
            hideIncludedServices: true
          })
        })
      })]
    })
  });
};